import React from 'react'
import SarasTimePicker from '../../input/timePicker/SarasTimePicker'
import * as fn from "../../../helper/uiFunctions";

const FormTimePicker = (props) => {
    const { formObject, action, rowKey, headerKey } = props
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "0");
    const useValF = formObject.getValueFromKey(viewData, "dataList.useValF", "0");

    const onChange = (e, value) => {
        // console.log("form input changed", e, action, value);
    
        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, value);
    
        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
    }

    const getValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        return value;
    }

    if(viewData && fn.compareNumber(hide, 0)){
        if(fn.compareNumber(isRO, 1)) {
            return (<span>{getValue()}</span>)
        }
        else{
            if(useValF)
            {
                return(
                    <SarasTimePicker value={viewData.valF}  onChange={onChange} />
                )
            }
            else{
                return(
                    <SarasTimePicker value={viewData.val}  onChange={onChange} />
                )
            }
        }
        
    }

    return(null);
}

export default FormTimePicker